module.exports = __webpack_public_path__ + "static/media/Computer.169cde85.png";